import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { getToken } from '../../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Mapea cada clave técnica a un nombre y descripción amigables
const INFO_AJUSTES = {
  descanso: {
    label: 'Descanso entre citas',
    description: 'Minutos de pausa obligatoria tras cada cita antes de permitir la siguiente.',
  },
  dias_maximos_reserva: {
    label: 'Días límite de reserva',
    description: 'Cantidad máxima de días por adelantado que puede reservar un cliente.',
  },
  horas_minimas_anticipacion: {
    label: 'Horas mínimas de antelación',
    description: 'Tiempo mínimo (en horas) antes de la cita para poder reservarla.',
  },
  horas_minimas_cancelacion: {
    label: 'Horas mínimas de cancelación',
    description: 'Tiempo mínimo (en horas) antes de la cita para poder cancelarla.',
  },
  umbral_contiguedad_dias: {
    label: 'Umbral de contigüidad',
    description: 'Número de días desde hoy en los que las nuevas citas deben ser contiguas a las ya existentes.',
  },
};

const AjustesAdmin = () => {
  const [ajustes, setAjustes] = useState({});
  const [edits, setEdits] = useState({});

  const cargarAjustes = async () => {
    const token = getToken();
    try {
      const res = await api.get('/ajustes', { headers: { Authorization: `Bearer ${token}` } });
      setAjustes(res.data);
      setEdits(res.data);
    } catch (err) {
      console.error('❌ Error al cargar ajustes:', err);
      toast.error('Error al cargar los ajustes');
    }
  };

  useEffect(() => {
    cargarAjustes();
  }, []);

  const handleChange = (clave, value) => {
    setEdits(prev => ({ ...prev, [clave]: value }));
  };

  const guardarAjuste = async (clave) => {
    const token = getToken();
    const valor = edits[clave];
    if (valor === '' || valor == null) {
      toast.warning('El valor no puede estar vacío');
      return;
    }
    try {
      await api.put(
        `/ajustes/${clave}`,
        { valor },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`"${INFO_AJUSTES[clave]?.label || clave}" actualizado`);
      await cargarAjustes();
    } catch (err) {
      console.error(`❌ Error al actualizar ajuste ${clave}:`, err);
      toast.error(`No se pudo actualizar "${INFO_AJUSTES[clave]?.label || clave}"`);
    }
  };

  return (
    <main className="site-width">
      <div className="texto-dashboard">
        <h1>Configuración del sistema</h1>
        <p>Ajusta los valores que controlan la disponibilidad y las reservas.</p>
      </div>

      <div className="grid-ajustes-admin">
        {Object.entries(ajustes).map(([clave, valorActual]) => {
          const info = INFO_AJUSTES[clave] || { label: clave, description: '' };
          return (
            <div key={clave} className="fila-ajuste">
              <div className="label-form" style={{ flex: 2 }}>
                <h3 htmlFor={`valor-${clave}`}><strong>{info.label}</strong></h3>
                <p className="descripcion-ajuste">{info.description}</p>
              </div>

              <div className="label-form" style={{ flex: 1 }}>
                <input
                  id={`valor-${clave}`}
                  type="number"
                  value={edits[clave] ?? ''}
                  onChange={e => handleChange(clave, e.target.value)}
                  placeholder="Valor"
                />
              </div>

                <button
                  className="boton-guardar-ajuste"
                  onClick={() => guardarAjuste(clave)}
                >
                  Guardar
                </button>
            </div>
          );
        })}
      </div>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </main>
  );
};

export default AjustesAdmin;
